import {drop, eq, filter, keyBy, last, take, first} from "lodash";
import {RoundStatus} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getRounds = (store: IStore) => store.rounds;

export const getActiveRound = createSelector([getRounds], (rounds) =>
	rounds.find((it) => it.status !== RoundStatus.Complete)
);

export const getFirstRound = createSelector([getRounds], (rounds) => first(rounds));

export const getFutureRounds = createSelector([getRounds], (rounds) => {
	const futureRounds = rounds.filter((it) => it.status !== RoundStatus.Complete);
	return take(drop(futureRounds, 1), 5);
});

export const getScheduledRounds = createSelector([getRounds], (rounds) =>
	rounds.filter((it) => it.status !== RoundStatus.Scheduled)
);

export const getRoundsById = createSelector([getRounds], (rounds) => keyBy(rounds, "id"));

export const getYesterdayCompletedRound = createSelector([getRounds], (rounds) => {
	const completeRounds = filter(rounds, (round) => eq(RoundStatus.Complete, round.status));

	if (completeRounds.length >= 2) {
		return last(completeRounds);
	}

	return null;
});
